import React from 'react';
import Tag from './tag';
import { AccessRole } from '@/types';

interface RoleTagProps {
  role: AccessRole | string;
  className?: string;
}

const getColorScheme = (role: string) => {
  switch (role) {
    case 'owner':
      return 'blue';
    case 'editor':
      return 'green';
    case 'worker':
      return 'yellow';
    case 'viewer':
      return 'gray';
    default:
      return 'gray';
  }
};

const RoleTag: React.FC<RoleTagProps> = ({ role, className }) => (
  <Tag colorScheme={getColorScheme(role)} className={`${className} capitalize`}>
    {role}
  </Tag>
);

export default RoleTag;
